import { Typography, Button, Card } from '../../components/primitives';
import { useTranslation } from '@rpi/i18n';
import { useNavigate } from 'react-router-dom';

export const CartWithoutItems = () => {
  const { t } = useTranslation(undefined, { keyPrefix: 'route.cart' });

  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/user/projects');
  };

  return (
    <div className="flex flex-col px-6 md:px-0 space-y-8">
      <Card data-testid="empty-cart">
        <div className="space-y-8 p-8">
          <div className="flex flex-col space-y-2">
            <Typography
              data-testid="empty-cart"
              as="h2"
              variant="title-default"
            >
              {t('empty_cart')}
            </Typography>
            <Typography as="p" variant="body">
              {t('empty_cart_description')}
            </Typography>
          </div>
          <div className="max-w-[150px]">
            <Button data-testid="my-projects" onClick={handleClick}>
              {t('my_projects')}
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
};
